import React, { Component } from 'react';

import './index.less';
import part1 from '../../img/part/i1.png';
import part2 from '../../img/part/i2.png';
import part3 from '../../img/part/i3.png';

class index extends Component {
    state = {}
    render() {
        return (
            <div className="parts">
                <div className="part">
                    <img src={part1} alt="" />
                    <div className="part-title">
                        多维度识别人才
                    </div>
                    <div className="part-intro">
                        全面评价候选人，揭示“冰山”下隐藏属性，价值观、性格、胜任力、认知能力，描绘一张完整的人才画像！
                    </div>
                </div>
                <div className="part">
                    <img src={part2} alt="" />
                    <div className="part-title">
                        人岗匹配参考
                    </div>
                    <div className="part-intro">
                        准确识别人才，帮助企业从众多候选人中，择优劣汰，选对、留住、用好人才。
                    </div>
                </div>
                <div className="part">
                    <img src={part3} alt="" />
                    <div className="part-title">
                        把关求职者心理风险
                    </div>
                    <div className="part-intro">
                        降低雇佣风险，帮助企业识别候选人难以发觉的风险因素，防止其带来的危害工作关系或影响工作效率。
                    </div>
                </div>
            </div>
        );
    }
}

export default index;